// extracted by mini-css-extract-plugin
export default {"gallery":"c-m_gS","gallery__header":"c-m_gT","gallery__thumbs":"c-m_gU"};